<template>
  <div class="separator" :class="{ 'ready': isReady }"></div>
</template>

<script>
export default {
  props: ['isReady']
}
</script>

<style scoped lang="scss">
  .separator {
    margin: auto;
    width: 80%;
    border-bottom: 1px solid lightgray;
    border-color: #FF792C;

    &.ready {
      border-color: #70BE00;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Separator.vue